import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  class: "tw-inline-block",
  ref: "root"
}
const _hoisted_2 = { class: "tw-m-0 tw-list-none tw-p-0" }
const _hoisted_3 = {
  key: 0,
  class: "tw-px-3 tw-py-1"
}
const _hoisted_4 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_5 = {
  key: 1,
  class: "tw-px-3 tw-py-1"
}
const _hoisted_6 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_7 = {
  key: 2,
  class: "tw-px-3 tw-py-1"
}
const _hoisted_8 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_9 = {
  key: 3,
  class: "tw-px-3 tw-py-1"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_12 = {
  key: 0,
  "uk-spinner": ""
}
const _hoisted_13 = {
  key: 4,
  class: "tw-px-3 tw-py-1"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_16 = {
  key: 0,
  "uk-spinner": ""
}
const _hoisted_17 = {
  key: 5,
  class: "tw-px-3 tw-py-1"
}
const _hoisted_18 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_19 = {
  key: 6,
  class: "tw-px-3 tw-py-1"
}
const _hoisted_20 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_21 = {
  key: 7,
  class: "tw-px-3 tw-py-1"
}
const _hoisted_22 = ["href"]
const _hoisted_23 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_24 = {
  key: 8,
  class: "tw-px-3 tw-py-1"
}
const _hoisted_25 = ["href"]
const _hoisted_26 = { class: "tw-flex tw-items-center tw-gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-md tw-text-slate-600 hover:tw-bg-white/80 hover:tw-text-slate-900",
      "aria-label": "Actions",
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)), ["stop"]))
    }, [
      _createVNode(_component_font_awesome_icon, {
        icon: "ellipsis-vertical",
        class: "tw-h-4 tw-w-4"
      })
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.isOpen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "tw-fixed tw-inset-0 tw-z-[9999]",
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, [
            _createElementVNode("div", {
              ref: "menuEl",
              class: "tw-absolute tw-min-w-[220px] tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-py-1 tw-shadow-lg",
              style: _normalizeStyle(_ctx.menuStyle),
              onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("ul", _hoisted_2, [
                (!_ctx.isEditing)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "tw-w-full tw-text-left tw-text-sm tw-text-slate-700 hover:tw-text-blue-600",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.emitAndClose('edit')))
                      }, [
                        _createElementVNode("span", _hoisted_4, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "pen-to-square",
                            class: "tw-h-4 tw-w-4 tw-text-slate-500"
                          }),
                          _cache[12] || (_cache[12] = _createElementVNode("span", null, "Edit Trip", -1))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isEditing)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "tw-w-full tw-text-left tw-text-sm tw-text-slate-700 hover:tw-text-blue-600",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.emitAndClose('addBefore')))
                      }, [
                        _createElementVNode("span", _hoisted_6, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "arrow-up",
                            class: "tw-h-4 tw-w-4 tw-text-slate-500"
                          }),
                          _cache[13] || (_cache[13] = _createElementVNode("span", null, "Add Trip Before", -1))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isEditing)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "tw-w-full tw-text-left tw-text-sm tw-text-slate-700 hover:tw-text-blue-600",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.emitAndClose('addAfter')))
                      }, [
                        _createElementVNode("span", _hoisted_8, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "arrow-down",
                            class: "tw-h-4 tw-w-4 tw-text-slate-500"
                          }),
                          _cache[14] || (_cache[14] = _createElementVNode("span", null, "Add Trip After", -1))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showStartTrip)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "tw-w-full tw-text-left tw-text-sm tw-text-emerald-700 hover:tw-text-emerald-800",
                        disabled: _ctx.isActionPending,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.emitAndClose('startTrip')))
                      }, [
                        _createElementVNode("span", _hoisted_11, [
                          (_ctx.isActionPending)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12))
                            : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                key: 1,
                                icon: "play",
                                class: "tw-h-4 tw-w-4 tw-text-emerald-700"
                              })),
                          _createElementVNode("span", null, _toDisplayString(_ctx.isActionPending ? 'Starting...' : 'Start Trip'), 1)
                        ])
                      ], 8, _hoisted_10)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showCompleteTrip)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "tw-w-full tw-text-left tw-text-sm tw-text-rose-700 hover:tw-text-rose-800",
                        disabled: _ctx.isActionPending,
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.emitAndClose('completeTrip')))
                      }, [
                        _createElementVNode("span", _hoisted_15, [
                          (_ctx.isActionPending)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16))
                            : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                key: 1,
                                icon: "circle-check",
                                class: "tw-h-4 tw-w-4 tw-text-rose-700"
                              })),
                          _createElementVNode("span", null, _toDisplayString(_ctx.isActionPending ? 'Completing...' : 'Complete Trip'), 1)
                        ])
                      ], 8, _hoisted_14)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showRevertTrip)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "tw-w-full tw-text-left tw-text-sm tw-text-slate-700 hover:tw-text-blue-600",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.emitAndClose('revertTrip')))
                      }, [
                        _createElementVNode("span", _hoisted_18, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "rotate-left",
                            class: "tw-h-4 tw-w-4 tw-text-slate-500"
                          }),
                          _cache[15] || (_cache[15] = _createElementVNode("span", null, "Revert Trip", -1))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showCancelTrip)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "tw-w-full tw-text-left tw-text-sm tw-text-slate-700 hover:tw-text-blue-600",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.emitAndClose('cancelTrip')))
                      }, [
                        _createElementVNode("span", _hoisted_20, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "ban",
                            class: "tw-h-4 tw-w-4 tw-text-slate-500"
                          }),
                          _cache[16] || (_cache[16] = _createElementVNode("span", null, "Cancel Trip", -1))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isEditing)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                      _createElementVNode("a", {
                        href: _ctx.printDispatchHref,
                        target: "_blank",
                        class: "tw-block tw-w-full tw-text-left tw-text-sm tw-text-slate-700 hover:tw-text-blue-600 tw-no-underline hover:tw-no-underline",
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                      }, [
                        _createElementVNode("span", _hoisted_23, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "print",
                            class: "tw-h-4 tw-w-4 tw-text-slate-500"
                          }),
                          _cache[17] || (_cache[17] = _createElementVNode("span", null, "Print Dispatch Sheet", -1))
                        ])
                      ], 8, _hoisted_22)
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isEditing)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                      _createElementVNode("a", {
                        href: _ctx.printBLHref,
                        target: "_blank",
                        class: "tw-block tw-w-full tw-text-left tw-text-sm tw-text-slate-700 hover:tw-text-blue-600 tw-no-underline hover:tw-no-underline",
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                      }, [
                        _createElementVNode("span", _hoisted_26, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "file-lines",
                            class: "tw-h-4 tw-w-4 tw-text-slate-500"
                          }),
                          _cache[18] || (_cache[18] = _createElementVNode("span", null, "Print BL", -1))
                        ])
                      ], 8, _hoisted_25)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 4)
          ]))
        : _createCommentVNode("", true)
    ]))
  ], 512))
}